module.exports = __webpack_public_path__ + "img/BOUTON_OFF.a03d5024.png";